import React from 'react'
import ThreeDLineDetails from './add-lines'
import ThreeDPlygonDetails from './add-polygon'
import ThreeDCircleDetails from './add-circle'

const MapObjects = (props) => {
  return (
    <>
      {props.drawType == 'circle' ? <ThreeDCircleDetails /> : null}
      {props.drawType == 'line' ? <ThreeDLineDetails /> : null}
      {props.drawType == 'polygon' ? <ThreeDPlygonDetails /> : null}
    </>
  )
}

export default MapObjects